<mat-card >
    <mat-card-content class="scrollable-card">
        <h4 class="mb-32 fw-bold">{{'SCHOOL_PROGRAM_ATTENDANCE_CHART'|translate}}</h4>

        <div class="max-width">
            <div class="form-group row">
                <div class="col-md-6">
                    <app-select-school (schoolChanged)="onChangeSchool($event)" [isDisabled]="!academic_year">
                    </app-select-school>
                </div>

            </div>
        </div>
        <div *ngIf="!hasData && !loading"  class="d-flex justify-content-center align-items-center mt-5 mb-5" style="height:30vh">
            <h3>{{'NO_DATA_AVAILABLE'|translate}}</h3>
        </div>
        <div *ngIf="!hasData && loading" class="d-flex justify-content-center align-items-center mb-5" style="margin-top: 50px">
            <mat-spinner></mat-spinner>
        </div>
        <div id="chart" style="margin-top: 30px" *ngIf="hasData && !loading">
            <div *ngIf="byLocation">
                <mat-icon (click)="getFilteredExcul()">arrow_back</mat-icon>
            </div>
            <apx-chart
                    [series]="chartOptions.series"
                    [chart]="chartOptions.chart"
                    [dataLabels]="chartOptions.dataLabels"
                    [plotOptions]="chartOptions.plotOptions"
                    [xaxis]="chartOptions.xaxis"
                    [stroke]="chartOptions.stroke"
                    [fill]="chartOptions.fill"
                    [yaxis]="chartOptions.yaxis"
                    [title]="chartOptions.title"
                    [tooltip]="chartOptions.tooltip"
                    [legend]="chartOptions.legend"
            ></apx-chart>
        </div>
    </mat-card-content>
</mat-card>
